<template>
    <div class="grid-app">
        <table v-if="is_table" class="grid-content"></table>

        <div v-else class="grid-content">
            <slot name="rows" :rows="rows"></slot>
        </div>

        <div class="paginate" v-if="pages > 1">
            <div class="paginate-buttons mt-3 mb-5">
                <button :class="'btn btn-navegacao ' + (page_on <= 1 ? 'disabled' : '')"
                        @click="prevPage"
                        :data-tippy-content="page_on <= 1 ? 'Você está na primeira página' : 'Ir à página anterior'">
                    <i class="fas fa-angle-left"></i> Anterior
                </button>

                <select class="form-select paginate-select" v-model="page_on">
                    <option v-for="page in pages"
                            :key="page"
                            :value="page">
                        {{ page }}
                    </option>
                </select>

                <button :class="'btn btn-navegacao ' + (page_on === pages ? 'disabled' : '')"
                        @click="nextPage"
                        :data-tippy-content="page_on === pages ? 'Você está na última página' : 'Ir à próxima página'">
                    Próxima <i class="fas fa-angle-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { urlApi, avisoErro } from '@/config/global'

    export default {
        name: 'Grid',

        props: {
            is_ajax: {
                type: Boolean,
                default: true
            },
            url_ajax: {
                type: String,
                default: ''
            },
            data_ajax: {
                type: Object,
                default: () => ({})
            },
            is_table: {
                type: Boolean,
                default: true
            },
            is_slot: {
                type: Boolean,
                default: false
            },
            nr_pagina_atual: {
                type: Number,
                default: 0
            },
            qtd_registros_por_pagina: {
                type: Number,
                default: 20
            },
            ajax_set_result: {
                type: Function,
                default: (r) => r
            },
            ajax_set_count: {
                type: Function,
                default: (r) => r.data.rows.itensCount
            },
            reload: {
                type: Number,
                default: 0
            }
        },

        data() {
            return {
                rows: [],
                qtd_records: 0,
                pages: 0,
                page_on: 1,
                tippy_instance: null,
                isAlive: true,
                rowsTimeout: null,
                abortController: null
            }
        },

        methods: {
            async getData() {
                if (!this.data_ajax || !this.isAlive) return

                if (this.abortController) {
                    this.abortController.abort()
                }

                this.abortController = new AbortController()

                const params = {
                    ...this.data_ajax,
                    qtdRegistrosPorPagina: this.qtd_registros_por_pagina,
                    nrPaginaAtual: this.page_on
                }

                try {
                    const res = await axios.get(`${urlApi}${this.url_ajax}`, {
                        params,
                        signal: this.abortController.signal
                    })

                    if (!this.isAlive) return

                    if (res.data?.success && res.data?.data) {
                        this.rows = this.ajax_set_result(res.data.data)
                        this.qtd_records = this.ajax_set_count(res.data)
                        this.paginate()
                    } else {
                        avisoErro('Não foi possível carregar os registros')
                    }
                } catch (error) {
                    if (error.name === 'CanceledError' || error.name === 'AbortError') {
                        return
                    }

                    if (this.isAlive) {
                        avisoErro('Não foi possível carregar os registros')
                    }
                }
            },

            paginate() {
                this.pages = Math.ceil(this.qtd_records / this.qtd_registros_por_pagina)

                if (this.pages < 1) {
                    this.pages = 0
                }

                if (this.page_on > this.pages && this.pages > 0) {
                    this.page_on = this.pages
                }
            },

            prevPage() {
                if (this.page_on > 1) {
                    this.page_on -= 1
                }
            },

            nextPage() {
                if (this.page_on < this.pages) {
                    this.page_on += 1
                }
            }
        },

        watch: {
            rows() {
                if (this.rowsTimeout) {
                    clearTimeout(this.rowsTimeout)
                }

                this.rowsTimeout = setTimeout(() => {
                    if (!this.isAlive) return
                    // tippy('.grid-content [data-tippy-content]')
                }, 200)
            },

            page_on(nValue, oValue) {
                if (
                    nValue !== oValue &&
                    this.is_ajax &&
                    this.data_ajax &&
                    this.isAlive
                ) {
                    this.getData()
                }
            },

            reload() {
                if (!this.isAlive) return

                const firstPage = this.nr_pagina_atual + 1

                if (this.page_on !== firstPage) {
                    this.page_on = firstPage
                    return
                }

                this.getData()
            }
        },

        mounted() {
            this.isAlive = true
            this.page_on = this.nr_pagina_atual + 1
        },

        beforeUnmount() {
            this.isAlive = false

            if (this.rowsTimeout) {
                clearTimeout(this.rowsTimeout)
            }

            if (this.abortController) {
                this.abortController.abort()
            }
        }
    }
</script>

<style lang="scss">
    .grid-app {
        .btn-navegacao {
            color: #fff;
            background-color: #6c757d;
            border-color: #6c757d;
            min-width: 140px;
        }

        .paginate-buttons {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
            flex-wrap: wrap;
        }

        .paginate-select {
            width: 120px;
            min-width: 120px;
        }
    }
</style>